import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}`;

const requestConfig = (token) => ({
  withCredentials: true,
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
});

const dataFrom = (response) => response?.data?.data ?? [];

const userRewardsService = {
  getSpecializations: async (token) => {
    const response = await axios.get(
      `${API_BASE_URL}/specialization/all`,
      requestConfig(token)
    );
    return dataFrom(response);
  },

  getSkills: async (token) => {
    const response = await axios.get(
      `${API_BASE_URL}/skills/all`,
      requestConfig(token)
    );
    return dataFrom(response);
  },

  getStages: async (token, skillId) => {
    const response = await axios.get(
      `${API_BASE_URL}/stages/all/${skillId}`,
      requestConfig(token)
    );
    return dataFrom(response);
  },

  getMilestones: async (token, specializationId) => {
    const response = await axios.get(
      `${API_BASE_URL}/user-rewards/admin/specializations/${specializationId}/milestones`,
      requestConfig(token)
    );
    return dataFrom(response);
  },

  saveMilestone: async (token, payload) => {
    const response = await axios.post(
      `${API_BASE_URL}/user-rewards/admin/milestones`,
      payload,
      requestConfig(token)
    );
    return response.data;
  },

  deactivateMilestone: async (token, milestoneId) => {
    const response = await axios.delete(
      `${API_BASE_URL}/user-rewards/admin/milestones/${milestoneId}`,
      requestConfig(token)
    );
    return response.data;
  },

  copyRewards: async (token, sourceSpecializationId, targetSpecializationId) => {
    const response = await axios.post(
      `${API_BASE_URL}/user-rewards/admin/specializations/${sourceSpecializationId}/copy/${targetSpecializationId}`,
      {},
      requestConfig(token)
    );
    return response.data;
  },
};

export default userRewardsService;
